import * as amplitude from "@amplitude/analytics-browser";

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

export function initAmplitude() {
  if (AMPLITUDE_API_KEY) {
    amplitude.init(AMPLITUDE_API_KEY);
  }
}

export function trackEvent(event, properties) {
  amplitude.track(event, properties);
}

export function setAmplitudeUserId(userId) {
  amplitude.setUserId(userId);
}
